import { useEffect, useState } from "react";
import "./Pagination.scss";
import { Pagination } from "react-bootstrap";
import { HiOutlineArrowRight, HiOutlineArrowLeft } from "react-icons/hi";
import { PaginationProps } from "../assets/interfaces/commom_interfaces";

const TablePagination = (props?: PaginationProps) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const totalItems = props?.totalItems ?? 0;
    const itemsCountPerPage = props?.itemsCountPerPage ?? 10;
    // useEffect(() => {
    //     setTotalPage(Math.ceil(totalItems / itemsCountPerPage));
    // }, [totalItems, itemsCountPerPage]);

    // useEffect(() => {
    //     props?.changePage && props?.changePage(currentPage);
    // }, [currentPage]);
    useEffect(() => {
        setTotalPage(Math.ceil(totalItems / itemsCountPerPage));
    }, [totalItems, itemsCountPerPage]);
    useEffect(() => {
        const nextPage = Number(props?.changeCurrentPage);

        if (!isNaN(nextPage) && nextPage > 0) {
            setCurrentPage((previousPage) =>
                previousPage === nextPage ? previousPage : nextPage
            );
        }
    }, [props?.changeCurrentPage]);
    useEffect(() => {
        if (totalPage > 0 && currentPage > totalPage) {
            setCurrentPage(totalPage);
        }
    }, [totalPage]);

    const handlePageChange = (page: number) => {
        if (page < 1 || page > totalPage || page === currentPage) return;

        setCurrentPage(page);
        props?.changePage && props.changePage(page);
    };

    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPage, startPage + maxVisiblePages - 1);
    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    if (totalItems <= itemsCountPerPage) return null;
    return (
        <div className="d-flex justify-content-center align-items-center table-pagination">
            <Pagination>
                <Pagination.Prev
                    className="pagination-btn"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    <HiOutlineArrowLeft size={18} />
                </Pagination.Prev>

                {[...Array(endPage - startPage + 1)].map((_, index) => {
                    const page = startPage + index;
                    return (
                        <Pagination.Item
                            key={page}
                            className={currentPage === page ? "currentPage" : ""}
                            // active={currentPage === page}
                            disabled={props?.showLoader}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </Pagination.Item>
                    );
                })}

                <Pagination.Next
                    className="pagination-btn"
                    disabled={currentPage === totalPage || totalPage === 0}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    <HiOutlineArrowRight size={18} />
                </Pagination.Next>
            </Pagination>
        </div>
    );
};

export default TablePagination;
